import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";

interface IdleTimeoutDialogProps {
    open: boolean;
    remainingTime: number;
    onStayActive: () => void;
    onLogout: () => void;
}

const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const IdleTimeoutDialog = ({
    open,
    remainingTime,
    onStayActive,
    onLogout,
}: IdleTimeoutDialogProps) => {
    const { t } = useTranslation("common", {
        keyPrefix: "idle-timeout",
    });

    return (
        <Dialog
            open={open}
            onClose={onStayActive}
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={1}>
                    <WarningAmberIcon color="warning" />
                    <Typography variant="h6">{t("title")}</Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {t("description")}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        my: 3,
                    }}
                >
                    <Typography
                        variant="h3"
                        component="div"
                        sx={{
                            fontWeight: "bold",
                        }}
                    >
                        {formatTime(remainingTime)}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onLogout} color="inherit">
                    {t("logout-now")}
                </Button>
                <Button onClick={onStayActive} variant="contained" autoFocus>
                    {t("stay-logged-in")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
